enum ARRAY_INDEX {
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
}

export { ARRAY_INDEX };
